import styles from './ccf-no-assignments-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfNoAssignmentsIconProps {}

export function CcfNoAssignmentsIcon(props: CcfNoAssignmentsIconProps) {
  return (
    <div className={styles['container']}>
      <h1>Welcome to CcfNoAssignmentsIcon!</h1>
    </div>
  );
}

export default CcfNoAssignmentsIcon;
